var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-content',[_c('el-header',{attrs:{"slot":"header"},slot:"header"}),_c('el-modules-permission-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }